import React, { useRef } from 'react'
import './contact.css'
import emailjs from'@emailjs/browser'
import toast from 'react-hot-toast';


const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_zfhkjn2', 'template_fwlwk8j', form.current, {
        publicKey: '70LVv-bVsluWpoUpo',
      })
      
      toast.success('Email Sent Successfully')

      e.target.reset()
    };
    

  return (
    <div className='contact-section'>
      <h1 className="contact-heading">Contact Us</h1>
      <div className="contact">
        <form ref={form} action="" className='form-data' id='form' onSubmit={sendEmail}>
            <input type="text" placeholder='Your Name' required className='your-name' name='from_name'/>
            <input type="email" placeholder='Your Email' required className='your-email' name='from_email'/>
            <textarea rows={6} type="text" placeholder='Your Messege' required className='your-messege' name='message'/>
          <div className="buttons">
            <input type="reset" value="Reset" className='reset-btn' />
            <input type="submit" value="Submit" className='submit-btn' />
          </div>
        </form>
      </div>
    </div>
  )
}

export default Contact
